// extracted by mini-css-extract-plugin
module.exports = {"content":"HeroVariant3_content__zQpqD","mobileImage":"HeroVariant3_mobileImage__jeAyh"};